import { useEffect, useMemo, useState } from "react";
import useAuth from "./useAuth";

/**
 * Perusahaan yang sedang dibuka.
 *
 * Untuk pengguna non-super-admin, nilainya otomatis mengikuti perusahaan milik
 * pengguna itu sendiri. Super admin dibiarkan null supaya bisa memilih sendiri
 * dari filter.
 *
 * DUA PERBAIKAN DARI VERSI SEBELUMNYA
 *
 * 1. `user.companies[0].company.name` diakses tanpa pengaman. Kalau AuthContext
 *    belum terisi, atau pengguna belum tertaut ke perusahaan mana pun, baris itu
 *    melempar TypeError dan seluruh halaman gagal render.
 *
 * 2. useState hanya memakai nilai awal. AuthContext umumnya terisi setelah
 *    render pertama, jadi pada versi lama perusahaan tidak pernah terpilih
 *    ketika data user datang belakangan - filter tampak kosong padahal
 *    penggunanya hanya punya satu perusahaan.
 */
export function useSelectedCompany() {
  const { user, isSuperAdmin } = useAuth();

  const defaultCompany = useMemo(() => {
    if (isSuperAdmin) return null;

    const first = user?.companies?.[0]?.company;
    if (!first?.id) return null;

    return { label: first.name, value: first.id };
  }, [isSuperAdmin, user?.companies]);

  const [selectedCompany, setSelectedCompany] = useState(defaultCompany);

  // Isi nilai default begitu data user tersedia, tanpa menimpa pilihan yang
  // sudah dibuat pengguna sendiri.
  useEffect(() => {
    if (!selectedCompany && defaultCompany) setSelectedCompany(defaultCompany);
  }, [defaultCompany, selectedCompany]);

  return [selectedCompany, setSelectedCompany];
}